function isNotEmpty (s) {
  if (typeof s == 'string' && s.length > 0) {
    return true
  }
  return false
}
/**
 * 精度取舍，不足补0
 * @param {string} numStr 数字
 * @param {string} n 小数位数
 * @return {string} 指定位小数位数的数字字符串
 * @author GuoYun
 */
function toFixWithZero (numStr, n) {
  if (n < 0) {
    return numStr
  }
  var endIndex = numStr.indexOf(".")
  if (numStr.indexOf(".") < 0) {
    return numStr + "." + getZeroSuffix(n)
  }
  endIndex = endIndex + 1 + n

  return endIndex >= numStr.length ? numStr + getZeroSuffix(endIndex - numStr.length) : numStr.substring(0, endIndex)
}

/**
 * 获得0尾缀
 * @param {number} n 需要补零的个数
 * @author GuoYun
 */
function getZeroSuffix (n) {
  return n > 0 ? new Array(n).fill(0).join('') : ''
}
/**
 * 返回文字列表铺满所占的行数
 * @param {Array} list 填充词列表
 * @param {number} rowMaxLen 一行最多填充多少文字
 * @param {number} interval 词间隔宽度=当前字体的文字个数
 * @author GuoYun
 */
function computeRowNumber (list, rowMaxLen = 16, interval = 1) {
  let row = 1
  let rowLen = 0
  list.forEach((x) => {
    const len = x.name
    const addLen = rowLen + len
    if (addLen > rowMaxLen) {
      row++
      rowLen = len + interval
    } else {
      rowLen = addLen + interval
    }
    console.log('compute', row, rowLen)
  })
  return row
}
module.exports = { toFixWithZero, getZeroSuffix, isNotEmpty,computeRowNumber }